import {
    MouseEvent as ReactMouseEvent, useCallback, useEffect, useRef, useState,
} from 'react';

interface UseDragResizeResult {
    width: number;
    onMouseDown: (event: ReactMouseEvent) => void;
}

const useDragResize = (initialWidth: number, min: number, max: number): UseDragResizeResult => {
    const [width, setWidth] = useState<number>(initialWidth);
    const dragRef = useRef<{ x: number; width: number } | null>(null);
    const widthRef = useRef<number>(initialWidth);
    widthRef.current = width;

    useEffect(() => {
        const onMove = (event: MouseEvent): void => {
            if (dragRef.current) {
                setWidth(Math.min(max, Math.max(min, dragRef.current.width + event.clientX - dragRef.current.x)));
            }
        };
        const onUp = (): void => {
            dragRef.current = null;
        };
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
        return () => {
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
        };
    }, [min, max]);

    const onMouseDown = useCallback((event: ReactMouseEvent) => {
        dragRef.current = { x: event.clientX, width: widthRef.current };
        event.preventDefault();
    }, []);

    return { width, onMouseDown };
};

export default useDragResize;
